module.exports = __webpack_public_path__ + "img/img31.8b6a80c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img31.jpg
// module id = 329
// module chunks = 0